<!-- 固顶操作栏 -->
<template>
  <div class="bottom-panel">
    <!-- 购买费率 -->
    <p v-if="isShowRate"
      class="buy-rate"
      @click="$goFundApp">购买费率：<span v-if="!$isEmpty(bottomRateInfo.oldRate)" class="old-rate rate"
      >{{bottomRateInfo.oldRate}}</span><span class="rate"
      >{{bottomRateInfo.rate}}</span><span class="rate"
      >{{bottomRateInfo.buyState}}</span><span
      >{{bottomRateInfo.buyPoint}}</span><img :src="RIGHT_ARROW" class="arrow" /></p>
    <!-- 按钮 -->
    <div class="btn-group row" ref="bottomRef">
      <div
        v-for="(item, index) in btnList"
        :key="index"
        @click="clickItem(item)"
        class="icon-btn-item">
        <img :src="item.src" class="icon" />
        <div>{{item.title}}</div>
        <div v-if="item.redDot && canShowRedDot" class="red-dot"></div>
      </div>
      <div class="multi-btn">
        <div v-if="isFullBtn" class="full-btn"
          :style="{backgroundImage: typeof buyInfo.img === 'string'
            ? `url(${buyInfo.img})` : buyInfo.img }"
            @click="() => { buyInfo.canClickBuy && $goFundApp() }"
            >{{buyInfo.text}}</div>
        <div v-else class="two-btn row">
          <div class="left-btn"
            :style="{backgroundImage: typeof investInfo.img === 'string'
            ? `url(${investInfo.img})` : investInfo.img}"
            @click="() => { investInfo.canClickInvest && goInvest() }">{{investInfo.text}}</div>
          <div class="right-btn"
            :style="{backgroundImage: typeof buyInfo.img === 'string'
            ? `url(${buyInfo.img})` : buyInfo.img }"
            @click="() => { buyInfo.canClickBuy && goBuy() }"
            >{{buyInfo.text}}</div>
        </div>
      </div>
    </div>
    <!-- 更多弹窗 -->
    <transition name="slide-fade">
      <more-list-popup
        v-if="showPopup"
        :cfh-info="cfhInfo"
        :basic-info="basicInfo"
        :detail-info="detailInfo"
        @cancel="() => { this.showPopup = false }" />
    </transition>
  </div>
</template>

<script>
import FULL_BUY from '@/assets/bottom/buy_big_light.png';
import HALF_BUY from '@/assets/bottom/buy_light.png';
import DINGTOU from '@/assets/bottom/dingtou_light.png';
import DISCUSS_ICON from '@/assets/ef_fund_detail_bar.png';
import FOLLOWED from '@/assets/followed.png';
import MORE_ICON from '@/assets/more.png';
import COMPARE_ICON from '@/assets/pk.png';
import UN_FOLLOW from '@/assets/un-follow.png';
import { wrapWxOpenLaunchAppLabel } from '@fund/wap-interface';
import options from '../../../../utils/options';
import MoreListPopup from './MoreListPopup.vue';

export default {

  name: 'bottom-panel',

  components: { MoreListPopup },

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    cfhInfo: {
      type: Object,
      default: () => ({}),
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      showPopup: false, // 展示更多弹窗
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
      FULL_BUY,
      FULL_BUY_DISABLED: 'https://j5.dfcfw.com/sc/image/202110/20211025112126.png',
      DINGTOU,
      DINGTOU_DISABLED: 'https://j5.dfcfw.com/sc/image/202110/20211025113638.png',
      HALF_BUY,
      HALF_BUY_DISABLED: 'https://j5.dfcfw.com/sc/image/202110/20211025113558.png',
      canShowRedDot: true, // 是否可展示讨论红点
      optionCodeList: [],
    };
  },

  computed: {
    btnList() {
      return [
        {
          src: DISCUSS_ICON,
          title: '讨论',
          redDot: true,
          clickEvent: () => {
            const curTime = new Date();
            const nowDay = `${curTime.getUTCFullYear()}-${curTime.getMonth()}-${curTime.getDate()}`;
            localStorage.setItem(`discuss-red-dot-${this.fundCode}`, nowDay);
            window.sendTrackLog('Div', 'Click', 'xpzy.pzy.tl.click', '');
            this.$goFundApp();
          },
        },
        {
          src: COMPARE_ICON,
          title: '对比',
          clickEvent: () => {
            window.sendTrackLog('Div', 'Click', 'xpzy.pzy.db.click', '');
            this.$goFundApp();
          },
        },
        {
          src: this.optionCodeList.includes(this.fundCode) ? FOLLOWED : UN_FOLLOW,
          title: this.optionCodeList.includes(this.fundCode) ? '设自选' : '加自选',
          clickEvent: () => {
            if (this.optionCodeList.includes(this.fundCode)) {
              this.setOption();
            } else {
              this.addOption();
            }
            window.sendTrackLog('Div', 'Click', 'xpzy.pzy.jzx.click', '');
          },
        },
        {
          src: MORE_ICON,
          title: '更多',
          clickEvent: () => {
            this.showPopup = true;
            window.sendTrackLog('Div', 'Click', 'xpzy.pzy.gd.click', '');
          },
        },
      ];
    },

    isShowRate() {
      return !this.basicInfo.isETF && this.basicInfo?.isSales;
    },
    bottomRateInfo() {
      const bottomRateInfo = this.detailInfo?.bottomRateInfo || {};
      return bottomRateInfo;
    },
    // 按钮样式 新发 加载状态 暂停申赎 封闭期是一个全按钮 其他状态是两个半按钮
    isFullBtn() {
      return (this.$isEmpty(this.basicInfo)
        || this.basicInfo?.isNewFund
        || this.basicInfo?.isDelListedFund
        || (!this.basicInfo?.canInvest && this.detailInfo?.isStopTrade)
        || !this.basicInfo?.isSales)
        && !this.basicInfo?.isETF;
    },
    buyInfo() { // 购买信息
      const canBuy = this.basicInfo?.canBuy || false;
      const canInvest = this.basicInfo?.canInvest || false;
      if (this.$isEmpty(this.basicInfo)) {
        return {
          img: this.FULL_BUY_DISABLED,
          text: '数据加载中',
          canClickBuy: false,
        };
      }
      if (this.basicInfo?.isDelListedFund) {
        return {
          img: this.FULL_BUY_DISABLED,
          text: '暂不开放购买',
          canClickBuy: false,
        };
      }
      if (!this.basicInfo?.isSales && !this.basicInfo?.isETF && !this.basicInfo?.isNewFund) {
        return {
          img: this.FULL_BUY_DISABLED,
          text: '暂不销售',
          canClickBuy: false,
        };
      }
      if (this.basicInfo?.isNewFund) { // 新发基金
        let text = this.basicInfo?.newFundBuyStatus;
        if (this.basicInfo?.newFundBuyStatus !== '购买') { // 基金非可购状态
          text = this.basicInfo?.newFundBuyStatus === '等待开售' ? '开售提醒' : text;
        } else { // 基金可购-平台销售状态
          text = this.basicInfo?.isSales ? '购买' : '暂不销售'; // 是否销售
        }
        // 新发基金 有多种状态 购买 开售提醒 等待成立 开放提醒（成立后就不再是新发基金，开放提醒当普通处理）
        return {
          img: ['等待成立', '已设置提醒'].indexOf(text) >= 0 || (!this.basicInfo?.isSales && text === '暂不销售')
            ? this.FULL_BUY_DISABLED
            : this.FULL_BUY,
          text,
          canClickBuy: this.basicInfo?.newFundBuyStatus !== '等待成立' && text !== '暂不销售',
          clickEvent: () => {},
        };
      }
      // ETF基金按钮始终高亮
      if (this.basicInfo.isETF) {
        return {
          img: this.HALF_BUY,
          text: '购买',
          canClickBuy: true,
        };
      }
      // 暂停申赎
      if (this.detailInfo?.isStopTrade) {
        if (!canInvest) {
          return {
            img: this.FULL_BUY,
            text: '开放提醒',
            canClickBuy: true,
            clickEvent: () => {},
          };
        }
      }
      return {
        img: canBuy ? this.HALF_BUY : this.HALF_BUY_DISABLED,
        text: '购买',
        canClickBuy: canBuy,
      };
    },
    // 定投状态
    investInfo() {
      const canInvest = this.basicInfo?.canInvest || false;
      if (this.basicInfo.isETF) {
        return {
          img: this.DINGTOU,
          text: '定投',
          canClickInvest: true,
        };
      }
      return {
        img: canInvest ? this.DINGTOU : this.DINGTOU_DISABLED,
        text: '定投',
        canClickInvest: canInvest,
      };
    },
  },

  mounted() {
    this.getOptionCodeList();
    const lastDay = localStorage.getItem(`discuss-red-dot-${this.fundCode}`);
    const curTime = new Date();
    const nowDay = `${curTime.getUTCFullYear()}-${curTime.getMonth()}-${curTime.getDate()}`;
    this.canShowRedDot = lastDay !== nowDay;
    // 处理微信点击
    if (this.$refs.bottomRef) {
      console.log('ref', this.$refs.bottomRef);
      wrapWxOpenLaunchAppLabel(this.$refs.bottomRef, {
        url: `fund://mp.1234567.com.cn/weex/fundb5035dd2ee584a/pages/fund-detail-public/index?currentCode=${this.fundCode}`,
      });
    }
  },

  methods: {
    // 判断登陆
    isLogin() {
      const currentHash = window.location.hash;
      const queryString = currentHash.slice(1);
      const params = new URLSearchParams(queryString);
      const json = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of params.entries()) {
        json[key] = value;
      }
      console.log('json', json);
      return json?.uid && json.passportctoken && json.passportutoken;
    },

    notLoginLink() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        // eslint-disable-next-line no-undef
        console.log(wx);
        // eslint-disable-next-line no-undef
        if (wx.miniProgram && wx.miniProgram.redirectTo) {
          // eslint-disable-next-line no-undef
          wx.miniProgram.redirectTo({
            url: '/pages/fund-login/home/index?source=lowcode',
          });
        }
        // #endif
      } else {
        this.$goFundApp();
      }
    },

    async addOption() {
      console.log('addOption', this.isLogin());
      if (!this.isLogin()) {
        this.notLoginLink();
        return;
      }
      const res = await options.addFundOption(this.fundCode);
      if (!res) {
        this.$optionEditGroup.showView(this.fundCode, this.basicInfo?.fundName);
      } else {
        this.$feedback.showToast({ title: res });
      }
      this.getOptionCodeList();
    },

    setOption() {
      if (!this.isLogin()) {
        this.notLoginLink();
        return;
      }
      this.$feedback.showActionSheet({
        itemList: ['删自选', '编辑分组', '自选置顶'],
        itemColor: ['#ff4400', '#000000', '#000000'],
        cancelText: '取消',
        cancelColor: '#000000',
        success: ({ tapIndex }) => {
          [
            this.deleteOption,
            this.editOption,
            this.optionToTop,
          ][tapIndex]();
        },
      });
    },

    async deleteOption() {
      if (!this.isLogin()) {
        this.notLoginLink();
        return;
      }
      const res = await options.deleteFundOption(this.fundCode);
      if (res) {
        this.getOptionCodeList();
      } else {
        this.$feedback.showToast({ title: '删除失败' });
      }
    },

    editOption() {
      this.$groupList.showView(this.fundCode, this.basicInfo?.fundName);
    },

    async optionToTop() {
      await options.setToTop(this.fundCode);
    },

    async getOptionCodeList() {
      if (!this.isLogin()) {
        return;
      }
      const res = await options.getFundOptionList();
      this.optionCodeList = res || [];
    },

    clickItem(item) {
      console.log(item);
      if (item.clickEvent) {
        item.clickEvent();
      } else {
        this.$goFundApp();
      }
    },
    goInvest() {
      this.$wxSendTrack('wxpzy.jy.dt.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.dt.click', '');
      this.$goFundApp();
    },
    goBuy() {
      this.$wxSendTrack('wxpzy.jy.gm.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.gm.click', '');
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({
          url: `/pages/buy-fund/index?fundCode=${this.fundCode}`,
        });
        return;
      }
      // #endif
      this.$goFundApp();
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-panel {
  border-top: 1px solid #eeeeee;
  width: 100%;
  min-height: 100px;
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  z-index: 1001;
  .buy-rate {
    margin: 0;
    text-align: center;
    font-size: 24px;
    color: #333333;
    line-height: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .old-rate {
      color: #999999;
      text-decoration: line-through;
    }
    .rate {
      margin-right: 8px;
    }
    .arrow {
      width: 32px;
      height: 32px;
      margin-left: 2px;
    }
  }
  .btn-group {
    height: 100px;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    justify-content: space-between;
    .icon-btn-item {
      position: relative;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      text-align: center;
      .icon {
        width: 42px;
        height: 42px;
      }
      .red-dot {
        position: absolute;
        top: 0;
        left: 40px;
        width: 10px;
        height: 10px;
        border-radius: 20px;
        background-color: #fa5914;
      }
    }
  }
  .multi-btn {
    width: 310px;
    height: 80px;
    justify-content: center;
    .full-btn {
      line-height: 80px;
      text-align: center;
      font-size: 32px;
      color: #ffffff;
      width: 310px;
      height: 80px;
      background-size: 310px 80px;
    }
    .two-btn {
      line-height: 80px;
      text-align: center;
      font-size: 32px;
      color: #ffffff;
      width: 310px;
      height: 80px;
      justify-content: center;
      .left-btn {
        flex:1;
        background-size: 100% 80px;
        background-repeat: no-repeat;
      }
      .right-btn {
        flex: 1;
        background-size: 100% 80px;
        background-repeat: no-repeat;
      }
    }
  }
}
</style>
